import React from 'react';



const QuestBody = () => {
    return (
            
          <div className="Quest-body">
            <div className="Quests-Container">
                <div className="Quest-Card_list">
                    <div className="Quest-Card_item">
                        <div className="Quest-Card_item_header">
                            <div className="Quest-Card_item_header_actions">
                                <div className="block">
                                    <h4>Daily</h4>
                                </div>
                            </div>
                            <div className="Quest-Card_item_header_media">
                                <img width="100%" alt="Open Zapper" src={process.env.PUBLIC_URL + "/images/open-zapper.png"} />
 
                            </div>
                            <div className="Quest-Card_item_header_text">
                                 <h4>Open Zapper</h4>
                            </div>
                        </div>
                        <div className="Quest-Card_item_body">
                            <div className="Quests-Card_item_between">
                                <p>100 XP - 75 V</p>
                            </div>
                            <p>Open Zapper everyday</p>
                             <div className="Quests-Card_item_address">
                               <a href="https://learn.zapper.fi/articles/what-is-zapper">Learn More</a>
                            </div>
                            <div className="button-body">
                            <button>Claim</button>
                            </div>
                        </div>
                    </div>
                    <div className="Quest-Card_item">
                        <div className="Quest-Card_item_header">
                            <div className="Quest-Card_item_header_actions">
                                <div className="block">
                                    <h4>Daily</h4>
                                </div>
                            </div>
                            <div className="Quest-Card_item_header_media">
                                <img width="100%" alt="Open Zapper" src={process.env.PUBLIC_URL + "/images/open-zapper.png"} />
 
                            </div>
                            <div className="Quest-Card_item_header_text">
                                 <h4>Open Zapper</h4>
                            </div>
                        </div>
                        <div className="Quest-Card_item_body">
                            <div className="Quests-Card_item_between">
                                <p>100 XP - 75 V</p>
                            </div>
                            <p>Open Zapper everyday</p>
                             <div className="Quests-Card_item_address">
                               <a href="https://learn.zapper.fi/articles/what-is-zapper">Learn More</a>
                            </div>
                            <div className="button-body">
                            <button>Claim</button>
                            </div>
                        </div>
                    </div>
                    <div className="Quest-Card_item">
                        <div className="Quest-Card_item_header">
                            <div className="Quest-Card_item_header_actions">
                                <div className="block">
                                    <h4>Daily</h4>
                                </div>
                            </div>
                            <div className="Quest-Card_item_header_media">
                                <img width="100%" alt="Open Zapper" src={process.env.PUBLIC_URL + "/images/open-zapper.png"} />
 
                            </div>
                            <div className="Quest-Card_item_header_text">
                                 <h4>Open Zapper</h4>
                            </div>
                        </div>
                        <div className="Quest-Card_item_body">
                            <div className="Quests-Card_item_between">
                                <p>100 XP - 75 V</p>
                            </div>
                            <p>Open Zapper everyday</p>
                             <div className="Quests-Card_item_address">
                               <a href="https://learn.zapper.fi/articles/what-is-zapper">Learn More</a>
                            </div>
                            <div className="button-body">
                            <button>Claim</button>
                            </div>
                        </div>
                    </div>
                    <div className="Quest-Card_item">
                        <div className="Quest-Card_item_header">
                            <div className="Quest-Card_item_header_actions">
                                <div className="block">
                                    <h4>Daily</h4>
                                </div>
                            </div>
                            <div className="Quest-Card_item_header_media">
                                <img width="100%" alt="Open Zapper" src={process.env.PUBLIC_URL + "/images/open-zapper.png"} />
 
                            </div>
                            <div className="Quest-Card_item_header_text">
                                 <h4>Open Zapper</h4>
                            </div>
                        </div>
                        <div className="Quest-Card_item_body">
                            <div className="Quests-Card_item_between">
                                <p>100 XP - 75 V</p>
                            </div>
                            <p>Open Zapper everyday</p>
                             <div className="Quests-Card_item_address">
                               <a href="https://learn.zapper.fi/articles/what-is-zapper">Learn More</a>
                            </div>
                            <div className="button-body">
                            <button>Claim</button>
                            </div>
                        </div>
                        
                    </div>
                    <div className="Quest-Card_item">
                        <div className="Quest-Card_item_header">
                            <div className="Quest-Card_item_header_actions">
                                <div className="block">
                                    <h4>Daily</h4>
                                </div>
                            </div>
                            <div className="Quest-Card_item_header_media">
                                <img width="100%" alt="Open Zapper" src={process.env.PUBLIC_URL + "/images/open-zapper.png"} />
 
                            </div>
                            <div className="Quest-Card_item_header_text">
                                 <h4>Open Zapper</h4>
                            </div>
                        </div>
                        <div className="Quest-Card_item_body">
                            <div className="Quests-Card_item_between">
                                <p>100 XP - 75 V</p>
                            </div>
                            <p>Open Zapper everyday</p>
                             <div className="Quests-Card_item_address">
                               <a href="https://learn.zapper.fi/articles/what-is-zapper">Learn More</a>
                            </div>
                            <div className="button-body">
                            <button>Claim</button>
                            </div>
                        </div>
                    </div>
                    <div className="Quest-Card_item">
                        <div className="Quest-Card_item_header">
                            <div className="Quest-Card_item_header_actions">
                                <div className="block">
                                    <h4>Daily</h4>
                                </div>
                            </div>
                            <div className="Quest-Card_item_header_media">
                                <img width="100%" alt="Open Zapper" src={process.env.PUBLIC_URL + "/images/open-zapper.png"} />
 
                            </div>
                            <div className="Quest-Card_item_header_text">
                                 <h4>Open Zapper</h4>
                            </div>
                        </div>
                        <div className="Quest-Card_item_body">
                            <div className="Quests-Card_item_between">
                                <p>100 XP - 75 V</p>
                            </div>
                            <p>Open Zapper everyday</p>
                             <div className="Quests-Card_item_address">
                               <a href="https://learn.zapper.fi/articles/what-is-zapper">Learn More</a>
                            </div>
                            <div className="button-body">
                            <button>Claim</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
          </div>
             
    )
}

export default QuestBody